import React, { useContext, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { AuthContext } from "../context/AuthContext";
import "../Styles/HampiLogin.css";
import logo from "../Images/LogoChangeBGRemoved.png";
import { CircularProgress } from "@mui/material";

export default function HampiLogin() {
  const { instance, accounts, inProgress } = useMsal();
  const authContext = useContext(AuthContext);
  const authError = authContext?.authError;
  const [loading, setLoading] = useState(false);
  const [sessionError] = useState(() => {
    const err = sessionStorage.getItem("hampi_auth_error");
    if (err) sessionStorage.removeItem("hampi_auth_error");
    return err;
  });

  console.debug('[HampiLogin] inProgress:', inProgress, '| accounts:', accounts.length);

  const handleLogin = async () => {
    try {
      setLoading(true);
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      console.error("Login redirect failed:", err);
      setLoading(false);
    }
  };

  return (
    <div className="main-l">
      <div className="Container-l">
        <div>
          <div className="img1">
            <img className="img-logo" loading="lazy" src={logo} alt="Logo" />
          </div>
          <div className="title">LOG IN</div>
        </div>

        {(sessionError || authError) && (
          <div
            style={{
              color: "#c0392b",
              background: "#fdf3f2",
              border: "1px solid #e74c3c",
              borderRadius: "6px",
              padding: "12px 16px",
              marginBottom: "16px",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            {sessionError || authError}
          </div>
        )}

        <div className="main-user-info">
          <p style={{ color: "#555", marginBottom: "24px", textAlign: "center" }}>
            Sign in with your company Microsoft account
          </p>

          {loading ? (
            <div className="input-field">
              <CircularProgress style={{ color: "purple" }} />
            </div>
          ) : (
            <button
              onClick={handleLogin}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "12px",
                padding: "10px 16px",
                borderRadius: "5px",
                background: "#50145A",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 21 21"
              >
                <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
              </svg>
              Sign in with Microsoft
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
